
//==================BEGIN DEPENDENCIES========================

import 'reflect-metadata';
  
import 'jquery';
  

//==================BEGIN UTILITY========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/node_modules/ui-core/utility/js/namespace';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/utility/js/utils';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/node_modules/ui-core/utility/js/tests';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/node_modules/ui-core/utility/ab-logger/js/ab-logger';
  

//==================BEGIN PLUGINS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/node_modules/ui-core/plugins/controller/js/controller';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/node_modules/ui-core/plugins/enquireJs/js/enquire';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/node_modules/ui-core/plugins/controller/js/enquireIt';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/node_modules/ui-core/plugins/truncate/js/truncate';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/node_modules/ui-core/plugins/magicSearch/js/magicsuggest';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/node_modules/ui-core/plugins/load-inview/js/load-inview';
  

//==================BEGIN VARIABLES========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/variables/js/grid-variables';
  

//==================BEGIN BASIC========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/basic/buttons/js/buttons';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/basic/base/js/base';
  

//==================BEGIN COMPONENTS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/components/generic-truncate/js/generic-truncate';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/components/drop-block/js/drop-block';
  

//==================BEGIN WIDGETS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/federated-login/js/federated-login';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/toc-article-group/js/toc-article-group';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/search-facets/js/search-facets';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/slot-license/js/slot-license';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/table-of-content/js/table-of-content';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/customPage-journal-header/js/customPage-journal-header';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/node_modules/ui-core/widgets/cookie-policy-popup/js/cookie-policy-popup';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/manage-alerts-legacy/js/manage-alerts-legacy';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/topical-alerts/js/topical-alerts';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/browse-taxonomies/js/browse-taxonomies';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/institution-banner/js/institution-banner';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/book-toc-header/js/book-toc-header';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/institutional-affiliations/js/institutional-affiliations';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619-achs-250519-e3ee39f5/ui-products/achs/widgets/editorsChoiceSubscription/js/editorsChoiceSubscription';
  

//==================BEGIN TEMPLATES========================


//==================BEGIN GROUPS========================

import './groups/_jcf';

import './groups/_jquery';

import tabsMain from './groups/_tabs';
const main = (UX) => {
    const $genericTruncate = Array.prototype.slice.call(document.querySelectorAll('.truncate-text,.truncate-list,.truncate-with-shadow')),
        $dropBlock = Array.prototype.slice.call(document.querySelectorAll('[data-db-target-for]')),
        $federatedLogin = Array.prototype.slice.call(document.getElementsByClassName('literatumSsoStartWidget')),
        $tocArticleGroup = Array.prototype.slice.call(document.getElementsByClassName('toc-article-group')),
        $searchFacets = Array.prototype.slice.call(document.getElementsByClassName('search__filters')),
        $intitutionId = Array.prototype.slice.call(document.getElementsByClassName('updateInstitutionMessageForm')),
        $tableOfContent = Array.prototype.slice.call(document.querySelectorAll('.infocus-book-toc, .table-of-content, .preview_button')),
        $cpJournalHeader = Array.prototype.slice.call(document.getElementsByClassName('cpJournalHeader')),
        $cookiePolicyPopupWidget = Array.prototype.slice.call(document.getElementsByClassName('cookiePolicy-popup')),
        $manageAlerts = Array.prototype.slice.call(document.getElementsByClassName('manageAlertsWidget')),
        $topicalAlerts = Array.prototype.slice.call(document.getElementsByClassName('topical-alerts-container')),
        $browseTaxonomies = Array.prototype.slice.call(document.getElementsByClassName('browse-taxonomies')),
        $InsinuationBanner = Array.prototype.slice.call(document.getElementsByClassName('list-of-issues-detailed')),
        $bookHeader = Array.prototype.slice.call(document.getElementsByClassName('book-toc-header')),
        $institutionAffiliations = Array.prototype.slice.call(document.getElementsByClassName('remote_institutional_access'))

try {
        UX.controller.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($genericTruncate.length ) {
            UX.genericTruncate.init($genericTruncate);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($dropBlock.length ) {
            UX.dropBlock.init($dropBlock);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($federatedLogin.length ) {
            UX.federatedLogin.init($federatedLogin);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($tocArticleGroup.length ) {
            UX.tocArticleGroup.init($tocArticleGroup);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($searchFacets.length ) {
            UX.searchFacets.init($searchFacets);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($intitutionId.length ) {
            UX.intitutionId.init($intitutionId);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($tableOfContent.length ) {
            UX.tableOfContent.init($tableOfContent);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($cpJournalHeader.length ) {
            UX.cpJournalHeader.init($cpJournalHeader);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($cookiePolicyPopupWidget.length ) {
            UX.cookiePolicyPopupWidget.init($cookiePolicyPopupWidget);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($manageAlerts.length ) {
            UX.manageAlerts.init($manageAlerts);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($topicalAlerts.length ) {
            UX.topicalAlerts.init($topicalAlerts);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($browseTaxonomies.length ) {
            UX.browseTaxonomies.init($browseTaxonomies);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($InsinuationBanner.length ) {
            UX.InsinuationBanner.init($InsinuationBanner);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($bookHeader.length ) {
            UX.bookHeader.init($bookHeader);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($institutionAffiliations.length ) {
            UX.institutionAffiliations.init($institutionAffiliations);
        }
    } catch (err) {
        console.error(err);
    }
    
tabsMain(UX);

}
import './webpack-public-path'
const importPromises = async () => {

    
    const { default: dynamicMain } = await import(/* webpackChunkName: 'dynamic-imports' */ './dynamic-imports');
    const promises = Object.values(await dynamicMain(UX));
    

    
    promises.push(await import(/* webpackChunkName: 'requestidlecallback-polyfill' */ 'requestidlecallback-polyfill'));
    let lazyPromise = new Promise(resolve => {
        window.requestIdleCallback(
            async () => {
                const { default: lazyMain } = await import(/* webpackChunkName: 'lazy-imports' */ './lazy-imports');
                await lazyMain(UX);
                resolve();
            },
            { timeout: 5000 }
        );
    });
    

    promises.push(lazyPromise);

    return Promise.all(promises);
};

const build = async (UX) => {
    

    main(UX);
    await importPromises();
    try {
        UX.abLogger.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.enquireIt.init();
    } catch (err) {
        console.error(err);
    }
    
};

build(UX).then(() => {
    console.debug('JS LOADED');
});

